import {
  LogoFileExtntionRequest,
  LogoFileExtntionResponse,
} from "../../views/Profile/AddRestaurant";
import { apiSlice } from "../apiSlice";
import {
  CreateSetMenuRequest,
  SetMenu,
  SetMenuImageUpdateRequest,
  UpdateSetMenuRequest,
} from "../setMenuSlice";

export interface MenuApiResponse {
  setMenuList: SetMenu[];
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;
export const setMenuService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createSetMenu: builder.mutation<string, CreateSetMenuRequest>({
      query: (requestData) => ({
        url: `https://adminhttps-createsetmenu${API_BASE_DOMAIN}/`,
        method: "POST",
        body: requestData,
        responseHandler: (response) => response.text(),
      }),
    }),

    getMenuListByRestaurantId: builder.query<MenuApiResponse, string>({
      query: (restaurantId) => ({
        url: `https://adminhttps-getsetmenulistbyrestaurantid${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),

    deleteSetMenu: builder.mutation<
      void,
      { restaurantId: string; setMenuId: string }
    >({
      query: (requestData) => ({
        url: `https://adminhttps-deletesetmenu${API_BASE_DOMAIN}/`,
        method: "DELETE",
        body: requestData,
      }),
    }),

    updateSetMenu: builder.mutation<string, UpdateSetMenuRequest>({
      query: (requestData) => ({
        url: `https://adminhttps-updatesetmenu${API_BASE_DOMAIN}/`,
        method: "PUT",
        body: requestData,
        responseHandler: (response) => response.text(),
      }),
    }),

    UploadSetMenuLogoFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      LogoFileExtntionRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-getsetmenuimageuploadurl${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
      }),
    }),

    getMenuItemList: builder.query({
      query: ({ restaurantId }) =>
        `https://adminhttps-getmenuitemsbyrestaurantidformenu${API_BASE_DOMAIN}/?restId=${restaurantId}&menuType=Single`,
    }),

    getMenuItemAllList: builder.query({
      query: ({ restaurantId }) =>
        `https://adminhttps-getmenuitemsbyrestaurantidformenu${API_BASE_DOMAIN}/?restId=${restaurantId}&menuType=All`,
    }),

    updateSetMenuImage: builder.mutation<any, SetMenuImageUpdateRequest>({
      query: (requestData) => ({
        url: `https://adminhttps-updatesetmenuimage${API_BASE_DOMAIN}/`,
        method: "POST",
        body: requestData,
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useCreateSetMenuMutation,
  useGetMenuListByRestaurantIdQuery,
  useLazyGetMenuListByRestaurantIdQuery,
  useDeleteSetMenuMutation,
  useUpdateSetMenuMutation,
  useUploadSetMenuLogoFileExtntionHttpsMutation,
  useLazyGetMenuItemListQuery,
  useLazyGetMenuItemAllListQuery,
  useUpdateSetMenuImageMutation,
} = setMenuService;
